import { FC } from 'react';
import classNames from 'classnames';
import colors from 'config/theme/colors';
import { Image } from 'components/Image';
import { getPageImageUrl, getOptionalMediaUrl } from 'helpers/imageUrls';
import { Share } from 'components/Share';
import { AlertBell } from 'components/AlertBell';
import { Row } from 'components/Row';
import { codeFormatter, sanitizeHtml } from 'helpers/utils';
import { IPage } from 'store/donatePage/types';

interface DonateProps {
  pageData: IPage;
  changeSrc: (ev: any) => void;
  showImage: boolean;
  isCondensedDescription: boolean;
  onDescriptionToggle: () => void;
  showAlertBell: boolean;
}

export const DonatePageDetails: FC<DonateProps> = ({
  pageData,
  changeSrc,
  showImage,
  isCondensedDescription,
  onDescriptionToggle,
  showAlertBell,
}) => {
  const textColor = pageData?.page_color_text || colors.white;

  return (
    <>
      {showImage && pageData?.has_image && (
        <Image
          className="donate-left-banner-image mb13"
          alt={`${pageData.value} logo`}
          src={getPageImageUrl(pageData)}
          onError={changeSrc}
        />
      )}
      <div className="donate-left-container">
        <Row $justifyContent="space-between" $alignItems="center">
          <span
            className="h3-dtm"
            dangerouslySetInnerHTML={{ __html: sanitizeHtml(pageData.value) }}
            style={{ color: textColor }}
          />
          {showAlertBell && <AlertBell color={textColor} />}
        </Row>
        <Share color={textColor} />
        {pageData.optional_file_arrangement === 'BELOW_PAGE_NAME' &&
          pageData?.has_optional_media && (
            <Image
              className="donate-left-banner-image mb13"
              alt={`${pageData.value} optional media`}
              src={getOptionalMediaUrl(pageData)}
            />
          )}
        <span
          className="body-text donate-left-container-description hideForSmall"
          dangerouslySetInnerHTML={{
            __html: sanitizeHtml(codeFormatter(pageData.desc)),
          }}
          style={{ color: textColor }}
        />
        {pageData.desc && (
          <div className="hidden-description">
            <span
              className={classNames('body-text donate-left-container-description', {
                isCondensed: isCondensedDescription,
                mb8: !isCondensedDescription,
              })}
              dangerouslySetInnerHTML={{ __html: sanitizeHtml(codeFormatter(pageData.desc)) }}
              style={{ color: textColor }}
            />
            <button
              className="description-toggle"
              onClick={onDescriptionToggle}
              style={{ color: textColor }}
            >
              {isCondensedDescription ? 'View more' : 'View less'}
            </button>
          </div>
        )}
        {pageData.optional_file_arrangement === 'BELOW_PAGE_DESCRIPTION' &&
          pageData?.has_optional_media && (
            <Image
              className="donate-left-banner-image mb13"
              alt={`${pageData.value} optional media`}
              src={getOptionalMediaUrl(pageData)}
            />
          )}
      </div>
    </>
  );
};
